import { render } from "./AddSocietePage.vue?vue&type=template&id=65afa7a3&ts=true"
import script from "./AddSocietePage.vue?vue&type=script&lang=ts"
export * from "./AddSocietePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__